import * as loaderActionTypes from './loaderActionTypes';

export const showLoader = () => ({
  type: loaderActionTypes.SHOW_LOADER,
});

export const hideLoader = () => ({
  type: loaderActionTypes.HIDE_LOADER,
});



// WEBPACK FOOTER //
// ./src/loader/loaderActions.js